import React from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../Svg/Svg'

function IconText({
  className,
  textClassName,
  label,
  iconSize,
  iconColour,
  iconType,
  iconRotation,
  iconTop,
}) {
  return (
    <div className={`mz-icon-text ${className}`}>
      <Svg
        size={iconSize}
        colour={iconColour}
        type={iconType}
        rotation={iconRotation}
        style={{ top: iconTop }}
      />
      <div className={`mz-icon-text-text ${textClassName}`}>{label}</div>
    </div>
  )
}

IconText.propTypes = {
  className: PropTypes.string,
  textClassName: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  iconTop: PropTypes.string,
  iconSize: PropTypes.number,
  iconColour: PropTypes.string,
  iconType: PropTypes.string.isRequired,
  iconRotation: PropTypes.string,
}

IconText.defaultProps = {
  iconSize: 1,
  iconColour: 'black',
  textClassName: '',
  className: '',
}

export default IconText